import {
  createOrderAirItem,
  MockOrderAirItem,
} from '@dapi/sdk/spec';
// eslint-disable-next-line import/no-cycle
import {
  multiCurrencyAirPricingRecords,
} from './air-pricing-records';
// eslint-disable-next-line import/no-cycle
import {
  fareInfo,
} from './fare';
import {
  fareFamilyCode
} from './flight';

export const orderAirItem: MockOrderAirItem = createOrderAirItem({
  template: {
    bounds: [],
    prices: multiCurrencyAirPricingRecords,
    fareFamilyCode,
    freeCheckedBaggageAllowanceItems: [
      {
        details: {
          type: 'piece',
          quantity: 3
        },
        flightIds: ['ST2'],
        travelerIds: []
      }
    ],
    fareInfos: [fareInfo]
  }
});
